import { RootState } from 'store';

const UserState = (state: RootState) => state.weeklyPlanner.runningLate;

export const selectRunningLate = (state: RootState) => UserState(state).runningLate;
